import { useState } from 'react'

import { useQuery } from '@apollo/client'
import { IconUser } from '@tabler/icons-react'

import {
  CommandAction,
  CommandModule,
  DEFAULT_WORKER_ACTIONS,
  DynamicActionsProps,
} from './config'
import {
  DynamicWorkerInfoActions,
  getWorkerInfoDefaultActions,
} from './DynamicWorkerInfoActions'

import { useProject } from '@/context/projectContext'
import { GET_WORKERS_FOR_SEARCH } from '@/modules/workers/graphQL'
import { getWorkerName } from '@/utils/index'

import {
  WorkersListForSearchUiQuery,
  WorkersListForSearchUiQueryVariables,
} from 'types/api.graphql'

export const DynamicWorkerActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
  addSubItemsToParent,
}) => {
  const { project, isProjectSelected } = useProject()

  const [currentWorkerIds, setCurrentWorkerIds] = useState<string[]>([])

  useQuery<WorkersListForSearchUiQuery, WorkersListForSearchUiQueryVariables>(
    GET_WORKERS_FOR_SEARCH,
    {
      variables: {
        searchString: debouncedSearchText,
        filter: {
          projectId: project?.id,
          shouldIncludeBuilderSubcontractors: true,
        },
        pagination: { limit: 10, offset: 0 },
      },
      skip:
        !isProjectSelected ||
        activePage !== CommandModule.Workers ||
        !debouncedSearchText?.length,
      onCompleted: (data) => {
        setCurrentWorkerIds(data?.workers?.map((worker) => worker.id))

        replaceParentSubItems(CommandModule.Workers, [
          ...DEFAULT_WORKER_ACTIONS,
          ...(data?.workers?.map(
            (worker) =>
              ({
                id: worker.id,
                name: getWorkerName(worker),
                description: worker.trade,
                icon: IconUser,
                subActions: getWorkerInfoDefaultActions(worker),
              }) as CommandAction
          ) ?? []),
        ])
      },
    }
  )

  return (
    <DynamicWorkerInfoActions
      activePage={activePage}
      workerIds={currentWorkerIds}
      debouncedSearchText={debouncedSearchText}
      replaceParentSubItems={replaceParentSubItems}
      addSubItemsToParent={addSubItemsToParent}
    />
  )
}
